export default {
  props: {
    tag: {
      type: String,
    },

    title: {
      type: Object,
    },

    body: {
      type: String,
    },

    contentBlock: {
      type: [Array, Object],
    },
  },

  components: {
    hotSolutionsContentBlock: () =>
      import('~/components/Organisms/Solutions/SolutionsContentBlock/SolutionsContentBlock.vue'),
  },
}
